import './App.scss';
import Settings from './components/Settings';

function App() {
  return (
    <>
      <h2 className="title">Dreamfox WooCommerce Delivery Date Plugin</h2>
      <Settings></Settings>
    </>
  );
}

export default App;
